import type { UserShowStatus } from './types';

export interface ProgressStatusSnapshot {
  status: UserShowStatus | null;
  watchedCount: number;
  totalEpisodes: number;
}

/** Four-state status transitions driven by episode progress. */
export function nextStatusOnEpisodeToggle(
  snap: ProgressStatusSnapshot,
  nextWatchedCount: number,
  markingWatched: boolean,
): UserShowStatus {
  if (markingWatched) {
    if (snap.totalEpisodes > 0 && nextWatchedCount >= snap.totalEpisodes) return 'completed';
    if (snap.status === 'watchlist' || snap.status === null || snap.status === 'removed') {
      return 'watching';
    }
    return snap.status;
  }
  return snap.status === 'completed' ? 'watching' : (snap.status ?? 'watching');
}
